'use client';

import { CheckboxField, Tooltip } from '@petsmart-ui/sparky';
import { useState } from 'react';

import { useDecisions, useUserSession } from '@libs/common-next';
import { getOktaAccessToken, isRememberMeTrue, setRememberMeCookie } from '@libs/core';

import './KeepSignedInCheckbox.scss';

export function KeepSignedInCheckbox() {
    const [rememberMe, setRememberMe] = useState(() => isRememberMeTrue());

    const { user } = useUserSession();
    const isSoftLoginFFEnabled = useDecisions('soft_login');

    const isAOSAgent = user?.oktatoken ?? getOktaAccessToken();
    const shouldShowCheckbox = isSoftLoginFFEnabled && !isAOSAgent;

    if (!shouldShowCheckbox) {
        return null;
    }

    return (
        <div className="keep-signed-in__field">
            <CheckboxField hideLegend label="Keep me signed in checkbox">
                <CheckboxField.Item
                    key="keepMeSignedIn"
                    text="Keep me signed in"
                    name="keepMeSignedIn"
                    checked={rememberMe}
                    onChange={(value: boolean) => {
                        setRememberMe(value);
                        setRememberMeCookie(value);
                    }}
                />
            </CheckboxField>

            <Tooltip enableHover data-testid="keep-signed-in--tooltip">
                Remember me on this device. You’ll still need to sign in for secure transactions. For your protection,
                use only on personal devices.
            </Tooltip>
        </div>
    );
}
